import { useTranslation } from "react-i18next";
import PageWrapper from "../../components/PageWrapper";
import useLanguage from "../../utils/useLanguage";
import { UserAuth } from "../../utils/AuthContext";
import { useContext, useEffect, useState } from "react";
import RoundedTable, {
  TABLE_CELL_TYPES,
} from "../../components/table-component/RoundedTable";
import CustomButton from "../../components/CustomButton";
import ErrorBox from "../../components/ErrorBox";
import Loader, { LOADER_SIZES } from "../../components/Loader";
import infoIcon from "../../assets/info.png";
import HotdropdownV2 from "../../components/HotdropdownV2";
import { useInvoices } from "../ai-organization/Invoices";

const BankInvoicesPage = () => {
  const { t } = useTranslation("general");
  const { currentDirection } = useLanguage();
  const { userData } = useContext(UserAuth);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalRecords: 0,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedCompany, setSelectedCompany] = useState();
  const { invoices, setInvoices } = useInvoices();
  const [companies, setCompanies] = useState([
    {
      name: "شركة الريادة",
      value: "company1",
    },
    {
      name: "شركة بيت المال",
      value: "company2",
    },
    {
      name: "شركة الاخوين",
      value: "company3",
    },
  ]);

  const tableTitles = [
    {
      keepOnMobile: true,
      value: "transactionNumber",
    },
    {
      keepOnMobile: true,
      value: "Actions",
    },
  ];

  const fetchInvoices = async () => {
    setLoading(true);
    try {
      const data = [
        {
          invoiceNumber: "INV-001",
        },
        {
          invoiceNumber: "INV-002",
        },
      ];
      // setInvoices(data || []);
      //     setPagination((prev) => ({
      //       currentPage: data?.data?.currentPage,
      //       totalPages: data?.data?.totalPages,
      //       totalRecords: data?.data?.totalRecords,
      //     }));
      setLoading(false);
    } catch (error) {
      console.log("error fetching invoices", error);
      setError("errorFetchingInvoices");
    } finally {
      setLoading(false);
    }
  };

  const tableRows = invoices?.map((invoice) => [
    {
      value: invoice.invoiceNumber,
      type: TABLE_CELL_TYPES.LINK,
      to: `/bank-invoices/${invoice.id}`,
      eclipseText: true,
      keepOnMobile: true,
    },
    {
      value: (
        <CustomButton
          title={t("info")}
          icon={infoIcon}
          iconSize={16}
          variant="blank"
        />
      ),
      type: TABLE_CELL_TYPES.ELEMENT,
      keepOnMobile: true,
    },
  ]);

  useEffect(() => {
    fetchInvoices();
  }, [pagination.currentPage]);

  return (
    <PageWrapper
      style={{ direction: currentDirection }}
      title={t("transactionsPage")}
      withBackButton
    >
      <div className="o-column o-column--gap-size_500 u-margin--top_500">
        <section>
          <div className="o-column o-column--gap-size_100 u-margin--bottom_400">
            <label>{t("company")}</label>
            <div>
              <HotdropdownV2
                initOptions={companies}
                selected={selectedCompany}
                setSelected={setSelectedCompany}
              />
            </div>
          </div>
          {loading && <Loader size={LOADER_SIZES.MEDIUM} />}
          {error && <ErrorBox>{t(error)}</ErrorBox>}
          {!loading && !error && (
            <RoundedTable
              titles={tableTitles}
              rows={tableRows}
              pagination={pagination}
              setPagination={setPagination}
            />
          )}
        </section>
      </div>
    </PageWrapper>
  );
};

export default BankInvoicesPage;
